import { Component, inject } from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiGroupItemComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoGroupingComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
    DxoSummaryComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { FilterConfig, GridPageComponent } from '../../common/grid-page.component';
import { PerformanceGridViewDto} from '@services';
import { CommonModule, DecimalPipe, PercentPipe } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { formatYearMonthKey } from 'src/app/shared/date-utils';
import { CapitalCasePipe } from 'src/app/pipes/capital-case.pipe';

@Component({
    selector: 'app-performance',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoSummaryComponent,
        DxoGroupingComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSortingComponent,
        DxoSearchComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxiGroupItemComponent,
        DxTemplateDirective,
        FilterPanelComponent,
        DxFormComponent,
        DecimalPipe,
    ],
    providers: [DecimalPipe, PercentPipe],
    templateUrl: './performance.component.html',
})
export class PerformanceComponent extends GridPageComponent<PerformanceGridViewDto> {
    private decimalPipe = inject(DecimalPipe);
    private percentPipe = inject(PercentPipe);

    protected override exportName: string = 'Performance Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.performance();

    private createPercentFilter = (field: string) => (filterValue: any, selectedFilterOperation?: string) => {
        if (filterValue === undefined || filterValue === null) {
            return null;
        }
        return [field, selectedFilterOperation || '>=', filterValue / 100];
    };

    efficiencyPercentFilter = this.createPercentFilter('efficiencyPercent');
    efficiencyPercentChangeFilter = this.createPercentFilter('efficiencyPercentChange');
    casesPerHourPercentChangeFilter = this.createPercentFilter('casesPerHourPercentChange');

    protected override filterConfig: FilterConfig[] = [
        { field: 'type', op: '=' },
        { field: 'date', op: '>=' },
        { field: 'volume', op: '>=' },
        { field: 'stdHours', op: '>=' },
        { field: 'stdTotal', op: '>=' },
        { field: 'efficiencyPercent', op: '>=', customFilter: this.efficiencyPercentFilter},
        { field: 'efficiencyPercentChange', op: '>=', customFilter: this.efficiencyPercentChangeFilter},
        { field: 'casesPerHour', op: '>=' },
        { field: 'casesPerHourPercentChange', op: '>=', customFilter: this.casesPerHourPercentChangeFilter},
        { field: 'palletPerHour', op: '>='},
    ];

    constructor() {
        super();
        this.init(PerformanceGridViewDto);
    }

    customizeNumberText = (value: { value: number }) => {
        return this.decimalPipe.transform(value.value, '1.0-2');
    };

    customizePercentText = (value: { value: number }) => {
        if (value.value == null) return '';

        return this.percentPipe.transform(value.value, '1.0-2');
    };

    formatDateKey = (cellInfo: any) => {
        return formatYearMonthKey(cellInfo?.value, String(cellInfo?.value ?? ''));
    };

    formatType = (cellInfo: any) => {
        if (!cellInfo.value) return '';
        return cellInfo.value;
    };
}